import { render, staticRenderFns } from "./CertificadosBase.vue?vue&type=template&id=b93ccf1a&"
import script from "./CertificadosBase.vue?vue&type=script&lang=ts&"
export * from "./CertificadosBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b93ccf1a', component.options)
    } else {
      api.reload('b93ccf1a', component.options)
    }
    module.hot.accept("./CertificadosBase.vue?vue&type=template&id=b93ccf1a&", function () {
      api.rerender('b93ccf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/CertificadosBase.vue"
export default component.exports